var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('TopBarTitleComponent',{attrs:{"title":"Términos y Condiciones"}}),_c('b-container',{staticClass:"pb-4 px-lg-4",attrs:{"fluid":""}},[_c('TermsPayButtonRecurrent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }